import React from 'react';
import styles from './ContactsDistributeModalTitleView.module.less';
export default function IconItem(props) {
    var _a = props.title, title = _a === void 0 ? '' : _a, _b = props.subTitle, subTitle = _b === void 0 ? '' : _b;
    return (React.createElement("div", { className: styles['modal-title'] },
        title,
        React.createElement("span", { className: "sub-title" }, subTitle)));
}
